// extracted by mini-css-extract-plugin
module.exports = {"loading":"projectList_loading__1O9Mn","projectList":"projectList_projectList__1zRfZ","projectListItem":"projectList_projectListItem__3QhE_","active":"projectList_active__2xuPX"};